import { render, staticRenderFns } from "./right_panel_performance_table_wrapper.vue?vue&type=template&id=41e12b81&scoped=true"
import script from "./right_panel_performance_table_wrapper.vue?vue&type=script&lang=js"
export * from "./right_panel_performance_table_wrapper.vue?vue&type=script&lang=js"
import style0 from "./right_panel_performance_table_wrapper.vue?vue&type=style&index=0&id=41e12b81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e12b81",
  null
  
)

export default component.exports